export default __webpack_public_path__ + "images/597e3b09ccda6e781960606b5287ded5.svg";